import { RouteConfig } from 'vue-router'
// import Layout from '@/layout/index.vue'

// 交易订单二级
const tradeRouter: RouteConfig = {
  path: '/trade-android',
  component: () => import('@/views/trade/android/index.vue'),
  redirect: '/trade-android/vip-board',
  meta: {
    title: 'Android VIP',
    hidden: true,
    icon: 'menu-trade'
  },
  children: [
    {
      name: 'TradeVipBoard',
      path: 'vip-board',
      component: () => import('@/views/trade/android/vip-board/index.vue'),
      meta: {
        title: 'VIP看板',
        showTitle: false
      }
    },
    {
      name: 'TradeVipAndroid',
      path: 'trade-vip',
      component: () => import('@/views/trade-android/trade-vip/index.vue'),
      meta: {
        title: 'VIP订单',
        showTitle: true
      }
    },
    {
      name: 'TradeVipInfoAndroid',
      path: 'trade-vip-info',
      component: () => import('@/views/trade-android/trade-vip-info/index.vue'),
      meta: {
        title: 'VIP基本信息',
        showTitle: true
      },
      redirect: '/trade-android/trade-vip-info/base-info',
      children: [
        {
          name: 'BaseInoAndroid',
          path: 'base-info',
          component: () => import('@/views/trade-android/trade-vip-info/base-info.vue'),
          meta: {
            title: 'VIP基本信息',
            showTitle: true
          }
        }
      ]
    },
    {
      name: 'VipPriceSystemAndroid',
      path: 'vip-price-system',
      component: () => import('@/views/trade-android/vip-price-system/index.vue'),
      meta: {
        title: 'VIP价格',
        showTitle: true
      }
    },
    {
      name: 'VipDiscountAndroid',
      path: 'vip-discount',
      component: () => import('@/views/trade-android/vip-discount/index.vue'),
      meta: {
        title: 'VIP优惠活动',
        showTitle: true
      }
    }
    // {
    //   name: 'TradeTubiAndroid',
    //   path: 'trade-tubi',
    //   component: () => import('@/views/trade-android/trade-tubi/index.vue'),
    //   meta: {
    //     title: '兔币订单',
    //     showTitle: true
    //   }
    // },
    // {
    //   name: 'TradeExchangeAndroid',
    //   path: 'trade-exchange',
    //   component: () => import('@/views/trade-android/trade-exchange/index.vue'),
    //   meta: {
    //     title: '汇率设置',
    //     showTitle: true
    //   }
    // }
  ]
}

export default tradeRouter
